import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="214.2627563" cy="142.0613708" r="0" />
				<g className="ear ear--right">
					<path className="fill fill--light panda--black" d="M274.3649292,166.2736206c0,0,11.2728271-1.6379089,20.791687-9.1886444
						c9.5188599-7.5507507,11.1143494-21.3884125,3.5635986-30.90728s-21.3883972-11.1143494-30.9072571-3.5635986
						c-9.5188904,7.5507431-13.6791992,18.1550217-13.6791992,18.1550217L274.3649292,166.2736206z" />
					<path className="fill panda--black" d="M275.508728,174.1457977l-2.2871399-15.7447357l1.1435852,7.8723602l-1.1782837-7.8677063
						c0.0932312-0.0139771,9.4059448-1.5086975,17.0255432-7.5533295c6.0674438-4.8125,7.087738-13.6637421,2.275238-19.7306366
						c-4.8125-6.067421-13.6647949-7.0882416-19.7306519-2.2752228
						c-7.6268616,6.0493011-11.1839294,14.7420502-11.2175903,14.8280182l-14.8114624-5.8110504
						c0.2019806-0.5142822,5.0704193-12.7004089,16.1409607-21.4822388
						c12.9417419-10.264122,31.8193665-8.0883408,42.0840149,4.8523788
						c10.2646484,12.9402084,8.0878296,31.8188705-4.8523865,42.0840378
						C289.0295105,172.0995026,276.0556335,174.0665588,275.508728,174.1457977z" />
				</g>
				<g className="ear ear--left">
					<path className="fill fill--light panda--black" d="M154.1605835,166.2736206c0,0-11.2728119-1.6379089-20.7916718-9.1886444
						c-9.5188751-7.5507507-11.114357-21.3884125-3.5636139-30.90728
						c7.5507507-9.5188675,21.3884125-11.1143494,30.9072723-3.5635986
						c9.5188751,7.5507431,13.6791992,18.1550217,13.6791992,18.1550217L154.1605835,166.2736206z" />
					<path className="fill panda--black" d="M153.016983,174.1457977c-0.5469208-0.0792389-13.5213165-2.0462952-24.5923462-10.828125
						c-12.9402084-10.2646484-15.1165085-29.1433105-4.8518677-42.0840378
						c10.265152-12.9396896,29.1427765-15.1180573,42.0840302-4.8523788
						c11.0705109,8.7818298,15.9389496,20.9679565,16.1409454,21.4822388l-14.8114471,5.8110504
						c-0.0222778-0.0549011-3.5974731-8.783905-11.2176056-14.8280182
						c-6.0658722-4.8119812-14.9176331-3.7932358-19.7306519,2.2752228
						c-4.8130188,6.0668945-3.7922058,14.9181366,2.274704,19.7306366c7.626358,6.0498199,16.8996887,7.535202,16.9913635,7.5486755
						L153.016983,174.1457977z" />
				</g>
				<path className="fill panda--white" d="M138.7770081,193.9500885c0,44.6381989,37.6783752,64.7990875,75.4857483,64.7990875
					s75.4857483-20.1608887,75.4857483-64.7990875c0-50.0987549-31.1744385-73.2291946-75.4857483-73.2291946
					S138.7770081,143.8513336,138.7770081,193.9500885z" />
				<g className="muzzle">
					<circle className="fill fill--light panda--white" cx="214.2627563" cy="228.2754974" r="23.522028" />
					<path className="fill--face nose" d="M223.8284149,222.4874268c0-0.0444031-0.0094452-0.0870972-0.0111847-0.1310425
						c-0.0017242-0.0214233-0.0031433-0.0425262-0.0054321-0.0639496c-0.1752319-3.0310211-4.3772888-5.4581604-9.5490417-5.4581604
						c-5.1785278,0-9.3853149,2.4334412-9.5500641,5.470459c-0.0022125,0.0211029-0.0037842,0.0423584-0.0054474,0.0636292
						c-0.0014038,0.0400085-0.0101471,0.0787506-0.0101471,0.1190643h0.0090485
						c-0.0200806,0.6416779,0.190033,1.30336,0.6997986,1.8957367l5.906189,5.5724335
						c1.4494476,1.6843567,4.4051819,1.6931763,5.8684692,0.0173187l5.9537659-5.6070862
						c0.4991302-0.5884399,0.7046051-1.2431793,0.6848297-1.8784027H223.8284149z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bear/Heads.js